<template>
  <!-- ケアオーケストレーターユーザー管理 -->
  <div id="COSettingUserInternal">
    <div id="container-center">
      <coSettingNavi v-bind:pageid='"COSettingUserInternal"'></coSettingNavi>
      <settingUser />
    </div>
    <div style="margin-top:10px;">
        <b-button class="backbutton is-primary" @click="back">戻る</b-button>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/careorchestrator/SettingNaviBar";
import contents from "@/components/mock/philips/careorchestrator/setting/UserContents";

export default {
  name: "COSettingUserInternal",
  methods: {
    back: function() {
      this.$router.push({ name: "COUploadCertificate" , params: { searchConditions: this.searchConditions }});
    },
  },
  data() {
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    let certificationFlag = this.$route.params["certificationFlag"];
    let searchConditions = this.$route.params["searchConditions"]
    return {
      careOrchestratorInstitutionId : careOrchestratorInstitutionId,
      certificationFlag: certificationFlag,
      searchConditions, searchConditions
    };
  },
  filters: {},
  components: {
    coSettingNavi: naviBar,
    settingUser: contents
  },
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/careorchestrator/COSettingUser.vue